<template>
  <div class="padding pb-10 flex justify-center flex-col items-center ">
		<div class="grid lg:grid-cols-3 grid-cols-1 w-full gap-10 lg:mt-10 mt-5">
			<div class="rounded-lg bg-white shadow-xl">
				<img src="https://res.cloudinary.com/vital-seguros/image/upload/v1671712148/APP/group-graphic-designers-discussing-laptop-their-desk_juzomt-_1__eqdztc.webp" alt="" class="rounded-t-lg w-full h-auto">
				<div class="p-5 text-center">
					<p class="text-primario font-semibold text-xl leading-tight mb-5">Mision</p>
					<p class="text-sm leading-tight text-texto">Somos una empresa 100% Colombiana que busca conectar a los clientes de las agencias de seguros con la digitalización de sus productos, mediante nuestra plataforma appweb.</p>
				</div>
			</div>
			<div class="rounded-lg bg-white shadow-xl">
				<img src="https://res.cloudinary.com/vital-seguros/image/upload/v1666303919/APP/confident-call-center-operator-talking-with-client_74855-4059_oqws5n.webp" alt="" class="rounded-t-lg w-full h-auto">
				<div class="p-5 text-center">
					<p class="text-primario font-semibold text-xl leading-tight mb-5">Vision</p>
					<p class="text-sm leading-tight text-texto">Ser el medio de comunicación más efectivo entre las empresas y los clientes, generando valor por medio de la digitalización de sus procesos e información, siendo un ecosistema sostenible para todos..</p>
				</div>
			</div>
			<div class="rounded-lg bg-white shadow-xl">
				<img src="https://res.cloudinary.com/vital-seguros/image/upload/v1671712033/APP/woman-driving-automobile_1_zwkfqj-_1__jovz2u.webp" alt="" class="rounded-t-lg w-full h-auto">
				<div class="p-5 text-center">
					<p class="text-primario font-semibold text-xl leading-tight mb-5">Reune toda la informacion de tus polizas en un solo lugar</p>
					<p class="text-sm leading-tight text-texto">Tenemos una plataforma muy completa, donde vas a poder afiliarte a una aseguradora y ver cuando desees todos tus seguros adquiridos.</p>
				</div>
			</div>
			<div class="rounded-lg bg-white shadow-xl">
					<img src="https://res.cloudinary.com/vital-seguros/image/upload/v1666303919/APP/confident-call-center-operator-talking-with-client_74855-4059_oqws5n.webp" alt="" class="rounded-t-lg w-full h-auto">
					<div class="p-5 text-center">
							<p class="text-primario font-semibold text-xl leading-tight mb-5">Quiero ser proveedor <br> de servicios</p>
							<p class="text-sm leading-tight text-texto">Si eres una empresa relacionada al gremio y te gustan los medios digitales, HELPRIME es tu mejor aliado para ofrecer tus servicios a la comunidad.</p>
					</div>
			</div>
			<div class="rounded-lg bg-white shadow-xl ">
					<img src="https://res.cloudinary.com/vital-seguros/image/upload/v1671712148/APP/group-graphic-designers-discussing-laptop-their-desk_juzomt-_1__eqdztc.webp" alt="" class="rounded-t-lg w-full h-auto">
					<div class="p-5 text-center">
							<p class="text-primario font-semibold text-xl leading-tight mb-5">Quiero ser <br> agencia HELPRIME</p>
							<p class="text-sm leading-tight text-texto">HELPRIME ofrece sus plataformas a las Agencias que deseen vincularse, digitalizar su negocio y tener un control total de sus clientes sin tener que gastar una millonada en desarrollo.</p>
					</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  
}
</script>
<style>
  
</style>